<!--  

FILTRO manifesto por tipo

-->



<script>

import { SysVars } from '../main';

export default {
    props: {
        query: Object,
    },

    data () {
        return {

            filtroTipos: {
                list: [
                    { id: -1, label: 'Todos' },
                    { id: 0, label: 'Sem Manifestação do Destinatário' },
                    { id: 1, label: 'Confirmada Operação' },
                    { id: 2, label: 'Desconhecida' },
                    { id: 3, label: 'Operação não Realizada' },
                    { id: 4, label: 'Ciência' },
                ],
                index: -1,
            },

            filtroManifestoSelected: null,
        }
    },

    components: {

    },

    computed: {
        labelManifesto: function () {
            return this.filtroTipos.list[this.$store.getters.getIndexfiltroTiposManifesto].label
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        handleChangeFiltroManifesto (index) {
            this.$store.commit('SET_INDEXFILTROTIPOSMANIFESTO', index)
            this.filtroManifestoSelected = this.filtroTipos.list[index]
            this.query.confdest = this.filtroManifestoSelected.id
            if (this.query.confdest == null)
              this.query.confdest = -1
            this.$emit('change', this.query.confdest)
        },


    },

    created () {
        
    }

}

</script>

<template>
    <div class="row align-items-center mb-3">
        <div class="col-12">
            <span class="lbl">Tipo Manifesto
                <a class="dropdown-toggle pr-2" style="cursor: pointer" tabindex="1" data-toggle="dropdown"> {{ labelManifesto }} <span class="caret"></span></a>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a class="dropdown-item" href="javascript:void(0)" 
                            v-for="(filtro, index) in filtroTipos.list" :key="index" 
                            @click="handleChangeFiltroManifesto(index)">{{ filtro.label }}</a>
                    </div>
            </span>
        </div>
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/components/manifesto-filtro.vue